const oneTimePurchase = document.getElementById("one-time-purchase");
const weeklySubscription = document.getElementById("weekly-subscription");
const weeklySubs = document.querySelectorAll(".weekly-sbs");
const primaryButton = document.querySelector("[data-action='primary']");

const promotionalOffers = {
  promo1: {
    mealRange: { min: 0, max: 10 },
    discounts: [29.6, 20, 20, 15, 15],
    notify: "Select 10 MEALS for $100 OFF & Free Shipping",
    perServing:8.99
  },
  promo2: {
    mealRange: { min: 10, max: 12 },
    discounts: [41.5,35.5,30,25,18], // 90
    notify: "Select 12 MEALS for $150 OFF & Free Shipping",
    perServing:8.49
  },
  promo3: {
    mealRange: { min: 12, max: 14 },
    discounts: [51.24,35,30,30,20], // 120
    notify: "Select 14 MEALS for $166 OFF & Free Shipping",
    perServing:8.29
  },
  promo4: {
    mealRange: { min: 14, max: 18 },
    discounts: [71.25,39.25,30,30,29.5], // 120
    notify: "Select 18 MEALS for $200 OFF & Free Shipping",
    perServing:7.99
  },
};

const oneTimeOffers = {
  promo1: {
    mealRange: { min: 0, max: 8 },
    discounts: 3,
    notify: "Select 8 MEALS for 3% OFF",
    offerDiscount: "3PERCENTOFF",
  },
  promo2: {
    mealRange: { min: 8, max: 12 },
    discounts: 5, // 90
    notify: "Select 12 MEALS for 5% OFF",
    offerDiscount: "5PERCENTOFF",
  },
  promo3: {
    mealRange: { min: 12, max: 16 },
    discounts: 10, // 120
    notify: "Select 16 MEALS for 10% OFF",
    offerDiscount: "10PERCENTOFF",
  }
};

const milestones = [
  {
    amount: 200,
    message: "10% Off achieved!",
    offerDiscount: "10PERCENTOFF",
    discounPercent: 10,
    offApplied: "10% OFF Applied",
  },
  {
    amount: 150,
    message: "Spend $200 for 10% OFF",
    offerDiscount: "5PERCENTOFF",
    discounPercent: 5,
    offApplied: "5% OFF Applied",
  },
  {
    amount: 100,
    message: "Spend $150 for 5% OFF",
    offerDiscount: "3PERCENTOFF",
    discounPercent: 3,
    offApplied: "3% OFF Applied",
  },
  {
    amount: 0,
    message: "Spend $100 for 3% OFF",
    offerDiscount: "",
    discounPercent: 0,
    offApplied: "",
  },
];

const userLoggedIn = ShopifyAnalytics.meta.page.customerId;
const subscriptionContractId = localStorage.getItem("contractInfo");

displayCartTotal();

async function getCartData() {
  const response = await fetch("/cart.json");
  const data = await response.json();
  return data;
}

function setLoadingState(activeButton, inactiveButton) {
  activeButton.disabled = true;
  activeButton.classList.add("loading");
  inactiveButton.disabled = true;
}

function resetLoadingState(activeButton, inactiveButton) {
  activeButton.classList.remove("loading");
  activeButton.classList.remove("buttonInActive");
  activeButton.classList.add("buttonActive");
  inactiveButton.classList.remove("buttonActive");
  inactiveButton.classList.add("buttonInActive");
  inactiveButton.disabled = false;
}

function validatedAddress() {
  const validAddress = localStorage.getItem("widgetAddress");
  if (validAddress !== null) {
    const addressResponse = JSON.parse(validAddress);
    const { address_line_combined, locality_name, state_territory, postcode } =
      addressResponse;

    const address = {
      "checkout[shipping_address][country]": "AU",
      "checkout[shipping_address][address1]": address_line_combined,
      "checkout[shipping_address][city]": locality_name,
      "checkout[shipping_address][province]": state_territory,
      "checkout[shipping_address][zip]": postcode,
    };
    // Filter out properties with undefined or empty values
    const filteredAddress = Object.fromEntries(
      Object.entries(address).filter(([key, value]) => value)
    );
    return filteredAddress;
  }
  return false;
}

function directToCheckoutSubcription(origin) {
  weeklySubscription.click();
  countinue_to_shipping(origin);
}

async function countinue_to_shipping(requestPath) {
  const cartData = await getCartData();
  const { attributes, total_price,original_total_price } = cartData;
  const orderType = attributes?.orderType || "WeeklySubscription";
  const discount_code = applicableDiscount(cartData);

  document.getElementById("continue_to_shipping").classList.add("loading");
  try {
    const addressParameters = validatedAddress();
    const queryString = Object.entries(addressParameters)
      .map(([key, value]) =>
        value ? `${key}=${encodeURIComponent(value)}` : ""
      )
      .filter(Boolean)
      .join("&");
    let checkoutUrl = `${shopUrl}/checkout?step=contact_information&${queryString}`;
    if (orderType === "OneTimePurchase") {
       if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("NDIS") && typeof customerData.ndisDiscountPercentage === "number") {
            if (((original_total_price/100)* (1 - customerData.ndisDiscountPercentage)) < MIN_NDIS_OTP_CART_AMOUNT) {
                $("#min-response").html(`You need minimum $${MIN_NDIS_OTP_CART_AMOUNT} to checkout`);
                document.getElementById("continue_to_shipping")
                          .classList.remove("loading");
                        return;
            }       
        }else{
          if ((total_price/100) < MIN_OTP_CART_AMOUNT) {
            $("#min-response").html(`You need minimum $${MIN_OTP_CART_AMOUNT} to checkout`);
            document
              .getElementById("continue_to_shipping")
              .classList.remove("loading");
            return;
        }
      }
      
      localStorage.setItem("subscription_type", "onetime");
      const otpResponse = await oneTimePurchaseFunction(cartData);
      if (otpResponse && requestPath === "mini-cart") {
        window.location.href = `${shopUrl}/pages/extras`;
      } else {
        const checkIfCastles = getCookie("Ip-validator");
        if (checkIfCastles === "true") {
          window.location.href = checkoutUrl;
        } else {
          window.location.href = discount_code
            ? `${checkoutUrl}&discount=${discount_code}`
            : checkoutUrl;
        }
      }
    } else if (orderType === "WeeklySubscription") {
          // console.log((total_price/100), MIN_NDIS_SUBS_CART_AMOUNT);
         if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("NDIS") && typeof customerData.ndisDiscountPercentage === "number") {
                       if (((original_total_price/100)* (1 - customerData.ndisDiscountPercentage)) < MIN_NDIS_SUBS_CART_AMOUNT) {
                        $("#min-response").html(
                            `You need minimum $${MIN_NDIS_SUBS_CART_AMOUNT} to subscribe for free shipping and checkout ndis`
                          );
                        document
                          .getElementById("continue_to_shipping")
                          .classList.remove("loading");
                        return;
                      }
                    
        }else{
        
      if ((total_price/100) < MIN_SUBS_CART_AMOUNT) {
        $("#min-response").html(
          `You need minimum $${MIN_SUBS_CART_AMOUNT} to subscribe for free shipping and checkout`
        );
        document
          .getElementById("continue_to_shipping")
          .classList.remove("loading");
        return;
      }
      }

      localStorage.setItem("subscription_type", "weekly");
      const weekResponse = await weeklySubscriptionFunction(cartData);
      if (weekResponse && requestPath == "mini-cart") {
        window.location.href = discount_code
          ? `${checkoutUrl}&discount=${discount_code}`
          : checkoutUrl;
      } else {
        const checkIfCastles = getCookie("Ip-validator");
        if (checkIfCastles === "true") {
          window.location.href = checkoutUrl;
        } else {
          window.location.href = discount_code
            ? `${checkoutUrl}&discount=${discount_code}`
            : checkoutUrl;
        }
      }
    }
  } catch (error) {
    console.error("Error:", error);
  }
  
}

async function updateSubscription() {
  try {
    const { total_price = 0, items = [] } = await getCartData();
    const cartAmountInDollars = total_price / 100;
    const { promoOffer = "", contractId = "" } = JSON.parse(
      subscriptionContractId || "{}"
    );

    if (promoOffer) {
      const result = promotionalOffers[promoOffer];
      if (result) {
        const mealsCount = countLunchAndDinnerMeals(items);
        const { min = 0, max } = result.mealRange;
        if (mealsCount < max) {
          $("#min-response").text(
            `You require a minimum of ${max} meals to update your promotion offer.`
          );
          return;
        }
      } else {
        console.error("Promo offer not found.");
      }
    }

    if (cartAmountInDollars < MIN_SUBS_CART_AMOUNT) {
      $("#min-response").text(
        `Add minimum $${MIN_SUBS_CART_AMOUNT} worth of products to Subscription`
      );
      return;
    }

    if (!contractId) {
      console.error("Contract information missing from local storage.");
      return;
    }

    localStorage.setItem("proxy-contract-id", contractId);
    localStorage.removeItem("contractInfo");

    window.location.href = `/apps/account/contract/${contractId}/subscription-callback`;
  } catch (error) {
    console.error("Error updating subscription:", error);
  }
}

oneTimePurchase.addEventListener("click", async () => {
  setLoadingState(oneTimePurchase, weeklySubscription);
  const cartResponse = await processCart(
    {
      attributes: {
        orderType: "OneTimePurchase",
        // Promotional: false,
      },
    },
    "cart/update.js"
  );
  updateCartInfo(cartResponse, '.cart-item-loop');
  try {
    weeklySubs.forEach((element) => {
      element.classList.add("d-none");
      element.classList.remove("d-block");
    });
  } catch (error) {
    console.error("Error:", error);
  }
  resetLoadingState(oneTimePurchase, weeklySubscription);
});

weeklySubscription.addEventListener("click", async () => {
  setLoadingState(weeklySubscription, oneTimePurchase);
  const cartResponse = await processCart(
    {
      attributes: {
        orderType: "WeeklySubscription",
      },
    },
    "cart/update.js"
  );
  updateCartInfo(cartResponse, '.cart-item-loop');
  try {
    weeklySubs.forEach((element) => {
      element.classList.remove("d-none");
      element.classList.add("d-block");
    });
  } catch (error) {
    console.error("Error:", error);
  }
  resetLoadingState(weeklySubscription, oneTimePurchase);
});

function clearCart() {
  return fetch(window.Shopify.routes.root + "cart/clear.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error("Error clearing cart:", error);
      throw error; // Rethrow the error for further handling
    });
}

function newCastleAmountANDItemValidation(cartData, variantID) {
  let cartValue = cartData.original_total_price;
  if (cartValue >= 8900) {
    const checkItemExistsOrNot = cartData.items.find(
      (item) => item.id === variantID
    );
    if (!checkItemExistsOrNot) {
      // console.log("Item ID variantID doesn't exist in the cart.");
      return false;
    } else {
      // console.log("Item ID  exists in the cart.");
      return true;
    }
  } else {
    // console.log("Cart value is not more than 99.");
    return true;
  }
}

function createFormData(cartData, deliveryInfo, isSubscription) {
  const { items: cartItems,attributes } = cartData;
  const checkIfCastles = getCookie("Ip-validator");
  const freeBeeVariantId = 46677447803196;
  let addFreeBee;

  const filteredCart = cartItems.map((cartItem) => ({
    id: cartItem.variant_id,
    properties: cartItem.properties,
    quantity: cartItem.quantity,
    // selling_plan: cartItem.variant_id === 46677447803196 ? null : (isSubscription ? 689703944508 : null),
    selling_plan: isSubscription ? 689703944508 : undefined,
  }));
  let applicableOffer;
  if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("NDIS") && typeof customerData.ndisDiscountPercentage === "number") {
    applicableOffer = false;
  }else{
    const responseMeals = countLunchAndDinnerMeals(cartData.items);
    applicableOffer = getPromoForMeals(responseMeals);
  }

  if (checkIfCastles === "true") {
    const castleResponse = newCastleAmountANDItemValidation(
      cartData,
      freeBeeVariantId
    );
    if (!castleResponse) {
      addFreeBee = {
        id: freeBeeVariantId,
        properties: { _freeBee: true },
        quantity: 1,
        selling_plan: 689703944508,
      };
    }
  }
  if (addFreeBee) {
    filteredCart.push(addFreeBee);
  }
  const { deliveryDate, deliveryEnd, deliveryStart, orderLate, packingDate } =
    JSON.parse(deliveryInfo) || {};

  const deliveryAttributes = {
    DeliveryDate: deliveryDate || "",
    PackingDate: packingDate || "",
    DeliveryStart: deliveryStart || "",
    DeliveryEnd: deliveryEnd || "",
    isOrderLate: orderLate ? "true" : "false",
    AddressType: "residential",
    promotional: isSubscription ? applicableOffer : false,
    orderType: attributes?.orderType ? attributes.orderType : "WeeklySubscription"
  };

  return {
    items: filteredCart,
    attributes: { ...deliveryAttributes },
  };
}

async function processCart(formData, endpoint) {
  try {
    return fetch(window.Shopify.routes.root + endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .finally(() => {
        // Reset loading state as needed
      });
  } catch (error) {
    console.error(`Error processing cart for ${endpoint}:`, error);
    throw error; // Rethrow the error for further handling
  }
}

async function oneTimePurchaseFunction(cartData) {
  const deliveryInfo = localStorage.getItem("deliveryInfo");
  const formData = createFormData(cartData, deliveryInfo, false);
  const clearCartData = await clearCart();
  return processCart(formData, "cart/add.js");
}

async function weeklySubscriptionFunction(cartData) {
  const deliveryInfo = localStorage.getItem("deliveryInfo");
  const formData = createFormData(cartData, deliveryInfo, true);
  const clearCartData = await clearCart();
  return processCart(formData, "cart/add.js");
}

const countLunchAndDinnerMeals = (items) => {
  return items.reduce((total, item) => {
    return item.product_type === "LUNCH & DINNER"
      ? total + item.quantity
      : total;
  }, 0);
};

const bundleMealsAmount = (items) => {
  return items.reduce((total, item) => {
    return item.product_type === "Bundle"
      ? total + item.original_price
      : total;
  }, 0);
};

async function displayCartTotal() {
  const cartResponse = await getCartData();
  // generateOfferDOM(cartResponse);
  updateCartInfo(cartResponse, '.cart-item-loop');
}

function generateOfferDOM(cart) {
  renderQuantitySelector(cart);
  if (subscriptionContractId && userLoggedIn) {
    subscriptionUpdateOffers(cart);
  } else {
    document.querySelector(".menu-banner")?.classList.remove("d-none");
    $(".subtotal-title-area li:first-child").show();
    $(".subsciption-update").remove();
    $(".create-order-btn").addClass("active");
    localStorage.removeItem("contractInfo");
    const orderType = cart?.attributes?.orderType || "WeeklySubscription";
    
    if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("NDIS") && typeof customerData.ndisDiscountPercentage === "number") {
          if (orderType === "OneTimePurchase") {
            NDISoneTimePurchaseOffers(cart);
          } else if (orderType === "WeeklySubscription") {
            NDISsubscriptionOffers(cart);
          }
      
    }else{
      if (orderType === "OneTimePurchase") {
        oneTimePurchaseOffers(cart);
      } else if (orderType === "WeeklySubscription") {
        subscriptionOffers(cart);
      }  
    }
  }
}

function renderQuantitySelector({ items }) {

  const productIds = items.map(item => item.product_id);

  const productElements = document.querySelectorAll('.product-all');

  productElements.forEach((productElement) => {
    const dataVariant = productElement.dataset.productId; // Get the product ID from data attribute
    
    const quantitySelector = productElement.querySelector('.quantity-selector');
    const addToCartSelector = productElement.querySelector('.add-cart-button');
    
    const matchedItem = items.find(item => item.product_id === Number(dataVariant));

    if (matchedItem) {
      const quantity = matchedItem.quantity; // Get quantity for the matched product
      const variantId = matchedItem.variant_id; // Get variant ID

      const quantityText = productElement.querySelector(`.quantity-${variantId}`);
      const quantityInput = productElement.querySelector('input.qtyinputcs');

      if (quantityText) {
        quantityText.textContent = quantity; // Set the quantity text
      }

      if (quantityInput) {
        quantityInput.value = quantity; // Set the quantity input field value
      }

      if (quantitySelector) {
        quantitySelector.classList.remove('d-none');
        quantitySelector.classList.add('d-block');
      }

      if (addToCartSelector) {
        addToCartSelector.classList.add('d-none');
      }
    } else {
      if (addToCartSelector) {
        addToCartSelector.classList.remove('d-none');
        addToCartSelector.classList.add('d-block');
      }

      if (quantitySelector) {
        quantitySelector.classList.add('d-none');
      }
    }
  });
}

function subscriptionUpdateOffers(cart) {
  $(".subtotal-title-area li:first-child").hide();
  $(".guest-order").remove();
  $(".update-subscription-btn").addClass("active");

  const cartAmountInDollars = cart.total_price / 100;

  $("#min-response").text(
    cartAmountInDollars < MIN_SUBS_CART_AMOUNT
      ? `Add minimum $${MIN_SUBS_CART_AMOUNT} worth of products to Subscription`
      : ""
  );

  document.querySelectorAll(".total-amount-with-disc").forEach((el) => {
    el.textContent = `$${cartAmountInDollars}`;
  });

  const {
    promoOffer = "",
    contractId = "",
    orderNo = 0,
  } = JSON.parse(subscriptionContractId || "{}");
  // console.log(promoOffer,orderNo,contractId);

  // Proceed if there is a promoOffer
  if (promoOffer) {
    const result = promotionalOffers[promoOffer] || null;
    // console.log(result);
    if (result) {
      const offerList = document.querySelector(".offer-bar-footer .offer-list");
   
      offerList.innerHTML = "";

      result.discounts.forEach((discount, index) => {
        const discountContentDiv = document.createElement("div");
        discountContentDiv.classList.add(
          "text-center",
          "position-relative",
          "custom-offerd-clc"
        );

        const badgeSpan = document.createElement("span");
        badgeSpan.classList.add(
          "badge",
          (index >= orderNo)  ? "bg-secondary" : "bg-orange",
          "d-block",
          "mb-2",
          "position-absolute",
          "right-0",
          "small"
        );
          badgeSpan.textContent = getOrdinalSuffix(index + 1);

        const iconElement = document.createElement("i");
        iconElement.classList.add(
          "icon-basket-loaded",
          "h2",
           (index >= orderNo)  ? "text-secondary" : "color-orange",
          "d-block",
          "mb-2",
          "mt-3"
        );

        const discountDiv = document.createElement("div");
        discountDiv.classList.add("small", "text-uppercase", "fw-bolder");
        discountDiv.textContent = `$${discount} off`;

        const dashDiv = document.createElement("div");
        dashDiv.classList.add("border-top", "border-secondary", "dashed-line");

        discountContentDiv.appendChild(badgeSpan);
        discountContentDiv.appendChild(iconElement);
        discountContentDiv.appendChild(discountDiv);
        offerList?.appendChild(discountContentDiv);
        offerList?.appendChild(dashDiv);
      });

    }
  }
}

function getOrdinalSuffix(number) {
  const lastDigit = number % 10;
  const lastTwoDigits = number % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
    return `${number}th`;
  }

  switch (lastDigit) {
    case 1:
      return `${number}st`;
    case 2:
      return `${number}nd`;
    case 3:
      return `${number}rd`;
    default:
      return `${number}th`;
  }
}

function oneTimePurchaseOffers(cart) {
  const offerLists = document.querySelectorAll(".offer-list"); // Selects all elements with class 'offer-list'
  document.querySelector(".total-applied-section")?.classList.add("d-none");
  document.querySelector(".per-serving-section")?.classList.add("d-none");
  document.querySelector(".free-shipping-section")?.classList.add("d-none");
  
  const offerListDetails = document.getElementById("offer-list-details");
  if (!offerLists) {
    console.error('Element with id "offer-list" not found');
    return;
  }
  const cartAmountInDollars = cart.original_total_price / 100;
   if (cartAmountInDollars < MIN_OTP_CART_AMOUNT) {
     if (primaryButton) {
        primaryButton.removeAttribute("onclick", "countinue_to_shipping('mini-cart')");
        primaryButton.classList.remove("checkPostalBtn2","bg-orange","border-orange");
        primaryButton.innerHTML = `Add $${(MIN_OTP_CART_AMOUNT - cartAmountInDollars).toFixed(2)} more to your cart`;
    }
  } else {
     if (primaryButton) {
        const deliveryDate = getCookie("expecting-delivery");
        if (deliveryDate !== null) {
            primaryButton.setAttribute("onclick", "countinue_to_shipping('mini-cart')");
            primaryButton.classList.add("bg-orange","border-orange");
            primaryButton.innerHTML = 'Checkout Now';
        } else {
            primaryButton.removeAttribute("onclick", "countinue_to_shipping('mini-cart')");
            primaryButton.classList.add("checkPostalBtn2");
            primaryButton.innerHTML = 'Select Delivery Date and Checkout';
        }
     }
  }
  
  let notificationMessage = "Save up to 10% on Meals";
  let activeOffer=null;
  const basePrice = cartAmountInDollars.toFixed(2);
 
  offerLists.forEach((list) => (list.innerHTML = ""));
  const mealsCount = countLunchAndDinnerMeals(cart.items);

  if (offerListDetails) {
    offerListDetails.innerHTML = "";
  }

  let bestOffer = false;
  let totalDiscount = 0;
  let prevPromo=null;
  Object.entries(oneTimeOffers).forEach(([promo, offer]) => {
    
    const { min, max } = offer.mealRange;
    totalDiscount = offer.discounts; //Math.round(offer.discounts.reduce((a, b) => a + b, 0));
    const li = document.createElement("li");
    const isBestOffer = mealsCount >= max;
    li.classList.add(
      "me-2",
      "d-flex",
      "align-items-center",
      "rounded-pill",
      isBestOffer ? "bg-gradient-success" : "bg-off-grey"
    );
    bestOffer = isBestOffer;

    if (mealsCount >= min && (max === null || mealsCount < max)) {
      notificationMessage= `${notificationMessage} <br><span class="small text-muted fs-12">${offer.notify}</span>`;

      const maxRange = max === null ? mealsCount : max;
      const widthPercentage = Math.min((mealsCount / maxRange) * 100, 100);

      const progressDiv = document.createElement("div");
      progressDiv.classList.add(
        "d-flex",
        "align-items-center",
        "justify-end",
        "rounded-pill",
        "bg-gradient-success-secondary"
      );
      progressDiv.style.transition = "width 1s";
      progressDiv.style.minWidth = "max-content";
      progressDiv.style.zIndex = "1";
      progressDiv.style.width = `${widthPercentage}%`;

      const innerDiv = document.createElement("div");
      innerDiv.classList.add(
        "d-flex",
        "align-items-center",
        "justify-center",
        "rounded-pill",
        "bg-white",
        "color-green",
        "border-green",
        "px-2",
        "dynamic-margin",
        "py-sm-0",
        "py-1"
      );
      innerDiv.textContent = `${mealsCount}/${maxRange}`;

      progressDiv.appendChild(innerDiv);
      li.style.width = "100%";
      li.classList.add("position-relative", "bg-off-grey");
      li.appendChild(progressDiv);

      const span = document.createElement("span");
      span.classList.add(
        "position-absolute",
        "right-0",
        "text-dark",
        "px-1",
        "py-sm-0",
        "py-1"
      );
      span.textContent = `${totalDiscount}% OFF`;
      li.appendChild(span);
     
      if (prevPromo && prevPromo.discounts && prevPromo.discounts.length > 0) {
      activeOffer=prevPromo;
      prevPromo.discounts.forEach((discount, index) => {
        const discountContentDiv = document.createElement("div");
        discountContentDiv.classList.add(
          "text-center",
          "position-relative",
          "custom-offerd-clc"
        );

        const badgeSpan = document.createElement("span");
        badgeSpan.classList.add(
          "badge",
          "bg-orange",
          "d-block",
          "mb-2",
          "position-absolute",
          "right-0",
          "small"
        );
        
        badgeSpan.textContent = getOrdinalSuffix(index + 1);
        const iconElement = document.createElement("i");
        iconElement.classList.add(
          "icon-basket-loaded",
          "h2",
          "color-orange",
          "d-block",
          "mb-2",
          "mt-3"
        );

        const discountDiv = document.createElement("div");
        discountDiv.classList.add("small", "text-uppercase", "fw-bolder");
        discountDiv.textContent = `$${discount}OFF`;

        const dashDiv = document.createElement("div");
        dashDiv.classList.add("border-top", "border-secondary", "dashed-line");

        discountContentDiv.appendChild(badgeSpan);
        discountContentDiv.appendChild(iconElement);
        discountContentDiv.appendChild(discountDiv);
        offerListDetails?.appendChild(discountContentDiv);
        offerListDetails?.appendChild(dashDiv);
      });
    }else{
        const span = document.createElement("span");
        span.classList.add("fw-bold", "text-black", "py-2");
        span.textContent = "Save up to 10% on Meals";
        offerListDetails?.appendChild(span);
    }
    } else {
      const span = document.createElement("span");
      span.classList.add(
        "rounded-pill",
        "top-0",
        "right-0",
        "text-dark",
        "p-1",
        "text-white",
        "text-center"
      );
      span.textContent = `${totalDiscount}%OFF`; // Insert the total discount value
      li.appendChild(span);
    }
    prevPromo = offer;
     
    offerLists.forEach((list) => list.appendChild(li.cloneNode(true)));
  });
  if (bestOffer) {
    offerLists.forEach((list) => (list.innerHTML = "")); // Clear the list before appending the best offer
    const li = document.createElement("li");
    li.classList.add(
      "me-2",
      "d-flex",
      "align-items-center",
      "rounded-pill",
      "bg-gradient-success"
    );
    li.style.width = "100%";
    const span = document.createElement("span");
    span.classList.add(
      "px-2",
      "py-1",
      "rounded-pill",
      "top-0",
      "right-0",
      "text-dark",
      "p-1",
      "text-white",
      "text-center"
    );
    span.textContent = `You’re saving 10% on Meals🎉`; // Insert the total discount value
    li.appendChild(span);
    activeOffer=oneTimeOffers.promo3;
    offerLists.forEach((list) => list.appendChild(li.cloneNode(true)));
  }
  document.querySelector(".offer-details-bar")?.classList.remove("d-none");

  
   let offApplied = activeOffer?.discounts[0] || 0;
   const discountedPrice = (cartAmountInDollars - offApplied).toFixed(2);

   document.querySelectorAll(".total-discount-amount").forEach((el) => {
     el.textContent = offApplied ? `$${basePrice}` : "";  // Conditional text content
   });

   document.querySelectorAll(".total-price-amount").forEach((el) => {
     el.textContent = `$${discountedPrice}`;
   });

   [".total-applied-section", ".free-shipping-section"].forEach((selector) => {
     document.querySelector(selector)?.classList.toggle("d-none", !activeOffer);
   });

   const perServingAmount = document.querySelector(".per-serving-amount");
   if (perServingAmount) {
     perServingAmount.textContent = `$${activeOffer?.perServing || ''}`;
   }
   if (activeOffer) {
     document.querySelectorAll(".total-applied-amount").forEach((el) => {
       el.textContent = `$${offApplied} OFF`;
     });
   }
  document.querySelectorAll(".notification-message-mini-cart").forEach((el) => {
    el.innerHTML = notificationMessage;  // Use textContent if it's plain text
  });
  
}

function subscriptionOffers(cart) {
  const offerLists = document.querySelectorAll(".offer-list"); // Selects all elements with class 'offer-list'
  const offerListDetails = document.getElementById("offer-list-details");
  if (!offerLists) {
    console.error('Element with id "offer-list" not found');
    return;
  }
  const cartAmountInDollars = cart.original_total_price / 100;
  if (cartAmountInDollars < MIN_SUBS_CART_AMOUNT) {
    if (primaryButton) {
      primaryButton.removeAttribute("onclick", "countinue_to_shipping('mini-cart')");
      primaryButton.classList.remove("checkPostalBtn2","bg-orange","border-orange");
      primaryButton.innerHTML = `Add <b>$${(MIN_SUBS_CART_AMOUNT - cartAmountInDollars).toFixed(2)}</b> more to your cart`;
    }
  } else {
    if (primaryButton) {
      const deliveryDate =  getCookie("expecting-delivery");
      if (deliveryDate !== null) {
          primaryButton.setAttribute("onclick", "countinue_to_shipping('mini-cart')");
          primaryButton.innerHTML = 'Checkout Now';
          primaryButton.classList.add("bg-orange","border-orange");
      } else {
          primaryButton.removeAttribute("onclick", "countinue_to_shipping('mini-cart')");
          primaryButton.classList.add("checkPostalBtn2");
          primaryButton.innerHTML = 'Select Delivery Date and Checkout';
      }
    }
  }
  
  let notificationMessage = "Save up to $275 on Meals and Delivery";
  let activeOffer=null;
  const basePrice = cartAmountInDollars.toFixed(2);
 
  offerLists.forEach((list) => (list.innerHTML = ""));
  const mealsCount = countLunchAndDinnerMeals(cart.items);

  if (offerListDetails) {
    offerListDetails.innerHTML = "";
  }
  
  let bestOffer = false;
  let totalDiscount = 0;
  let prevPromo=null;
  Object.entries(promotionalOffers).forEach(([promo, offer]) => {
    const { min, max } = offer.mealRange;
    totalDiscount = Math.round(offer.discounts.reduce((a, b) => a + b, 0));
    const li = document.createElement("li");
    const isBestOffer = mealsCount >= max;
    li.classList.add("me-2","d-flex","align-items-center","rounded-pill",
      isBestOffer ? "bg-gradient-success" : "bg-off-grey"
    );
    bestOffer = isBestOffer;

    if (mealsCount >= min && (max === null || mealsCount < max)) {      
      notificationMessage= `${notificationMessage} <br><span class="small text-muted fs-12">${offer.notify}</span>`;
      const maxRange = max === null ? mealsCount : max;
      const widthPercentage = Math.min((mealsCount / maxRange) * 100, 100);
      const progressDiv = document.createElement("div");
      progressDiv.classList.add(
        "d-flex",
        "align-items-center",
        "justify-end",
        "rounded-pill",
        "bg-gradient-success-secondary"
      );
      progressDiv.style.transition = "width 1s";
      progressDiv.style.minWidth = "max-content";
      progressDiv.style.zIndex = "1";
      progressDiv.style.width = `${widthPercentage}%`;

      const innerDiv = document.createElement("div");
      innerDiv.classList.add(
        "d-flex",
        "align-items-center",
        "justify-center",
        "rounded-pill",
        "bg-white",
        "color-green",
        "border-green",
        "px-2",
        "dynamic-margin",
        "py-sm-0",
        "py-1"
      );
      innerDiv.textContent = `${mealsCount}/${maxRange}`;

      progressDiv.appendChild(innerDiv);
      li.style.width = "100%";
      li.classList.add("position-relative", "bg-off-grey");
      li.appendChild(progressDiv);

      const span = document.createElement("span");
      span.classList.add(
        "position-absolute",
        "right-0",
        "text-dark",
        "px-1",
        "py-sm-0",
        "py-1"
      );
      span.textContent = `$${totalDiscount} OFF`;
      li.appendChild(span);

      if (prevPromo && prevPromo.discounts && prevPromo.discounts.length > 0) {
      activeOffer=prevPromo;
      prevPromo.discounts.forEach((discount, index) => {
        const discountContentDiv = document.createElement("div");
        discountContentDiv.classList.add(
          "text-center",
          "position-relative",
          "custom-offerd-clc"
        );

        const badgeSpan = document.createElement("span");
        badgeSpan.classList.add(
          "badge",
          "bg-orange",
          "d-block",
          "mb-2",
          "position-absolute",
          "right-0",
          "small"
        );
        
        badgeSpan.textContent = getOrdinalSuffix(index + 1);
        const iconElement = document.createElement("i");
        iconElement.classList.add(
          "icon-basket-loaded",
          "h2",
          "color-orange",
          "d-block",
          "mb-2",
          "mt-3"
        );

        const discountDiv = document.createElement("div");
        discountDiv.classList.add("small", "text-uppercase", "fw-bolder");
        discountDiv.textContent = `$${discount} off`;

        const dashDiv = document.createElement("div");
        dashDiv.classList.add("border-top", "border-secondary", "dashed-line");

        discountContentDiv.appendChild(badgeSpan);
        discountContentDiv.appendChild(iconElement);
        discountContentDiv.appendChild(discountDiv);
        offerListDetails?.appendChild(discountContentDiv);
        offerListDetails?.appendChild(dashDiv);
      });
    }else{
        const span = document.createElement("span");
        span.classList.add("fw-bold", "text-black", "py-2");
        span.textContent = "Save up to $275 on Meals and Delivery";
        offerListDetails?.appendChild(span);
    }
    } else {
      const span = document.createElement("span");
      span.classList.add(
        "rounded-pill",
        "top-0",
        "right-0",
        "text-dark",
        "p-1",
        "text-white",
        "text-center"
      );
      span.textContent = `$${totalDiscount}`; // Insert the total discount value
      li.appendChild(span);
    }
     prevPromo = offer;
     
    offerLists.forEach((list) => list.appendChild(li.cloneNode(true)));
  });
  if (bestOffer) {
    renderlastOffer(promotionalOffers.promo4);
    offerLists.forEach((list) => (list.innerHTML = "")); // Clear the list before appending the best offer
    const li = document.createElement("li");
    li.classList.add(
      "me-2",
      "d-flex",
      "align-items-center",
      "rounded-pill",
      "bg-gradient-success"
    );
    li.style.width = "100%";
    const span = document.createElement("span");
    span.classList.add(
      "px-2",
      "py-1",
      "rounded-pill",
      "top-0",
      "right-0",
      "text-dark",
      "p-1",
      "text-white",
      "text-center"
    );
    span.textContent = `You’re saving $${totalDiscount} 🎉`; // Insert the total discount value
    li.appendChild(span);
    activeOffer=promotionalOffers.promo4;
    offerLists.forEach((list) => list.appendChild(li.cloneNode(true)));
  }
  document.querySelector(".offer-details-bar")?.classList.remove("d-none");

  let offApplied = activeOffer?.discounts[0] || 0;  // Default to 0 instead of empty string
  const discountedPrice = (cartAmountInDollars - offApplied).toFixed(2);

  document.querySelectorAll(".total-discount-amount").forEach((el) => {
    el.textContent = offApplied ? `$${basePrice}` : "";  // Conditional text content
  });

  document.querySelectorAll(".total-price-amount").forEach((el) => {
    el.textContent = `$${discountedPrice}`;
  });

  [".total-applied-section", ".per-serving-section", ".free-shipping-section"].forEach((selector) => {
    document.querySelector(selector)?.classList.toggle("d-none", !activeOffer);
  });

  const perServingAmount = document.querySelector(".per-serving-amount");
  if (perServingAmount) {
    perServingAmount.textContent = `$${activeOffer?.perServing || ''}`;
  }
  if (activeOffer) {
    document.querySelectorAll(".total-applied-amount").forEach((el) => {
      el.textContent = `$${offApplied} OFF`;
    });
  }
  document.querySelectorAll(".notification-message-mini-cart").forEach((el) => {
    el.innerHTML = notificationMessage;  // Use textContent if it's plain text
  });
  
}

function renderlastOffer(prevPromo){
  const offerListDetails = document.getElementById("offer-list-details");
  prevPromo.discounts.forEach((discount, index) => {
        const discountContentDiv = document.createElement("div");
        discountContentDiv.classList.add(
          "text-center",
          "position-relative",
          "custom-offerd-clc"
        );

        const badgeSpan = document.createElement("span");
        badgeSpan.classList.add(
          "badge",
          "bg-orange",
          "d-block",
          "mb-2",
          "position-absolute",
          "right-0",
          "small"
        );
        
        badgeSpan.textContent = getOrdinalSuffix(index + 1);
        const iconElement = document.createElement("i");
        iconElement.classList.add(
          "icon-basket-loaded",
          "h2",
          "color-orange",
          "d-block",
          "mb-2",
          "mt-3"
        );

        const discountDiv = document.createElement("div");
        discountDiv.classList.add("small", "text-uppercase", "fw-bolder");
        discountDiv.textContent = `$${discount} off`;

        const dashDiv = document.createElement("div");
        dashDiv.classList.add("border-top", "border-secondary", "dashed-line");

        discountContentDiv.appendChild(badgeSpan);
        discountContentDiv.appendChild(iconElement);
        discountContentDiv.appendChild(discountDiv);
        offerListDetails?.appendChild(discountContentDiv);
        offerListDetails?.appendChild(dashDiv);
      });
}

function NDISoneTimePurchaseOffers(cart) {
  const offerLists = document.querySelectorAll(".offer-list"); // Selects all elements with class 'offer-list'
  document.querySelector(".total-applied-section")?.classList.add("d-none");
  document.querySelector(".per-serving-section")?.classList.add("d-none");
  document.querySelector(".free-shipping-section")?.classList.add("d-none");
  
  const offerListDetails = document.getElementById("offer-list-details");
  if (!offerLists) {
    console.error('Element with id "offer-list" not found');
    return;
  }
  const cartAmountInDollars = ((cart.original_total_price * (1 - customerData.ndisDiscountPercentage))/100).toFixed(2);
   if (cartAmountInDollars < MIN_NDIS_OTP_CART_AMOUNT) {
     if (primaryButton) {
        primaryButton.removeAttribute("onclick", "countinue_to_shipping('mini-cart')");
        primaryButton.classList.remove("checkPostalBtn2","bg-orange","border-orange");
        primaryButton.innerHTML = `Add $${(MIN_NDIS_OTP_CART_AMOUNT - cartAmountInDollars).toFixed(2)} more to your cart`;
    }
  } else {
     if (primaryButton) {
        const deliveryDate = getCookie("expecting-delivery");
        if (deliveryDate !== null) {
            primaryButton.setAttribute("onclick", "countinue_to_shipping('mini-cart')");
            primaryButton.classList.add("bg-orange","border-orange");
            primaryButton.innerHTML = 'Checkout Now';
        } else {
            primaryButton.removeAttribute("onclick", "countinue_to_shipping('mini-cart')");
            primaryButton.classList.add("checkPostalBtn2");
            primaryButton.innerHTML = 'Select Delivery Date and Checkout';
        }
     }
  }
}

function NDISsubscriptionOffers(cart) {
  const offerLists = document.querySelectorAll(".offer-list"); // Selects all elements with class 'offer-list'
  const offerListDetails = document.getElementById("offer-list-details");
  if (!offerLists) {
    console.error('Element with id "offer-list" not found');
    return;
  }
  const cartAmountInDollars = ((cart.original_total_price * (1 - customerData.ndisDiscountPercentage))/100).toFixed(2);
  
  if (cartAmountInDollars < MIN_NDIS_SUBS_CART_AMOUNT) {
    if (primaryButton) {
      primaryButton.removeAttribute("onclick", "countinue_to_shipping('mini-cart')");
      primaryButton.classList.remove("checkPostalBtn2","bg-orange","border-orange");
      primaryButton.innerHTML = `Add <b>$${(MIN_NDIS_SUBS_CART_AMOUNT - cartAmountInDollars).toFixed(2)}</b> more to your cart`;
    }
  } else {
    if (primaryButton) {
      const deliveryDate =  getCookie("expecting-delivery");
      if (deliveryDate !== null) {
          primaryButton.setAttribute("onclick", "countinue_to_shipping('mini-cart')");
          primaryButton.innerHTML = 'Checkout Now';
          primaryButton.classList.add("bg-orange","border-orange");
      } else {
          primaryButton.removeAttribute("onclick", "countinue_to_shipping('mini-cart')");
          primaryButton.classList.add("checkPostalBtn2");
          primaryButton.innerHTML = 'Select Delivery Date and Checkout';
      }
    }
  }
  
}

function getPromoForMeals(mealCount) {
  let lastPromo = false;
  for (const [promoName, offer] of Object.entries(promotionalOffers)) {
    const max = offer.mealRange.max;
    if (mealCount >= max) {
      lastPromo = promoName;
    }
  }
  return lastPromo;
}

function applicableDiscount(cartData) {
  const { attributes = {}, total_price, items } = cartData;
  const orderType = attributes.orderType ?? "WeeklySubscription"; // Default to 'WeeklySubscription'

  if (orderType === "OneTimePurchase") {
    if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("NDIS") && typeof customerData.ndisDiscountPercentage === "number") {
                        return `${customerData.ndisProductDiscount},${customerData.ndisShippingDiscount},`;
                    
                }else{
            const mealsCount = countLunchAndDinnerMeals(items);
            let discount;
            if (mealsCount >= oneTimeOffers.promo3.mealRange.max) {
              discount = oneTimeOffers.promo3.offerDiscount;
            } else if (mealsCount >= oneTimeOffers.promo2.mealRange.max) {
              discount = oneTimeOffers.promo2.offerDiscount;
            } else if (mealsCount >= oneTimeOffers.promo1.mealRange.max) {
              discount = oneTimeOffers.promo1.offerDiscount;
            }
            const offApplied = discount || null;
            return offApplied;
    }
  } else if (orderType === "WeeklySubscription") {
    if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("NDIS") && typeof customerData.ndisDiscountPercentage === "number") {
                       return `${customerData.ndisProductDiscount},${customerData.ndisShippingDiscount},`;
    }else  if (userLoggedIn && Array.isArray(customerData.tags) && customerData.tags.includes("275Offer") && typeof customerData.ndisDiscountPercentage === "number") {
      const cartAmountInDollars = (total_price / 100).toFixed(2);
      const cartAmountInDollarsNumber = parseFloat(cartAmountInDollars); // Convert to number
      if (cartAmountInDollarsNumber >= 150 && cartAmountInDollarsNumber < 200) {
        return EXISTING_SUBS_DIS5OFF;
      }
      if (cartAmountInDollarsNumber >= 200) {
        return EXISTING_SUBS_DIS10OFF;
      }
    
    }else{
      
    const responseMeals = countLunchAndDinnerMeals(items);
    const applicableOffer = getPromoForMeals(responseMeals);
    if (applicableOffer === "promo1") {
      return "10MEALS_OFFER";
    } else if (applicableOffer === "promo2") {
      return "12MEALS_OFFER";
    } else if (applicableOffer === "promo3") {
      return "14MEALS_OFFER";
    } else if (applicableOffer === "promo4") {
      return "18MEALS_OFFER";
    }
    return null;
    }
  }
  return null;
}

function oneTimePurchaseOffersOld(cart) {
  const offerLists = document.querySelectorAll(".offer-list");
  const cartAmountInDollars = cart.original_total_price / 100;
  
  // console.log({bundleAmount,cartAmountInDollars});
  
  if (cartAmountInDollars < MIN_OTP_CART_AMOUNT) {
    primaryButton.removeAttribute("onclick", "countinue_to_shipping('mini-cart')");
    primaryButton.classList.remove("checkPostalBtn2","bg-orange","border-orange");
    primaryButton.innerHTML = `Add $${(MIN_OTP_CART_AMOUNT - cartAmountInDollars).toFixed(2)} more to your cart`;
  } else {
      const deliveryDate = getCookie("expecting-delivery");
      if (deliveryDate !== null) {
          primaryButton.setAttribute("onclick", "countinue_to_shipping('mini-cart')");
          primaryButton.classList.add("bg-orange","border-orange");
          primaryButton.innerHTML = 'Checkout Now';
      } else {
          primaryButton.removeAttribute("onclick", "countinue_to_shipping('mini-cart')");
          primaryButton.classList.add("checkPostalBtn2");
          primaryButton.innerHTML = 'Select Delivery Date and Checkout';
      }
  }

  let notificationMessage = "";
  let offApplied = "";
  let discounPercent = "";

  for (let i = 0; i < milestones.length; i++) {
    if (cartAmountInDollars >= milestones[i].amount) {
      notificationMessage = milestones[i].message;
      offApplied = milestones[i].offApplied;
      discounPercent = milestones[i].discounPercent;
      break;
    }
  }
  const basePrice = cartAmountInDollars.toFixed(2);
  const discounts = (cartAmountInDollars * discounPercent) / 100;
  const discountedPrice = (cartAmountInDollars - discounts).toFixed(2);

  document.querySelectorAll(".total-discount-amount").forEach((el) => {
    if (discounPercent > 0) {
      el.textContent = `$${basePrice}`;
    } else {
      el.textContent = ""; // Clear if no discount
    }
  });

  document.querySelectorAll(".total-price-amount").forEach((el) => {
    el.textContent = `$${discountedPrice}`;
  });

  document.querySelector(".total-applied-section")?.classList.toggle("d-none", !offApplied);
  document.querySelector(".per-serving-section")?.classList.add("d-none");
  document.querySelector(".free-shipping-section")?.classList.add("d-none");
  
  document.querySelectorAll(".total-applied-amount").forEach((el) => {
    el.textContent = offApplied;
  });
  
  document.querySelectorAll(".notification-message-mini-cart").forEach((el) => {
    el.textContent = notificationMessage;
  });
  
  document.querySelector(".offer-details-bar")?.classList.add("d-none");

  offerLists.forEach((list) => {
    list.innerHTML = "";

    const cartProgressBar = document.createElement("div");
    cartProgressBar.className = "cartProgressBar";

    const fillBar = document.createElement("span");
    fillBar.className = "fillBar";

    const maxMilestone = 200;

    let progressWidth = (cartAmountInDollars / maxMilestone) * 100;

    fillBar.style.width = `${progressWidth}%`; // Set the width style based on progress
    cartProgressBar.appendChild(fillBar);

    const iconsData = [
      { className: "minSpand fill", title: "3% Off on $100", text: "3%" },
      { className: "fivePercent fill", title: "5% Off on $150", text: "5%" },
      { className: "tenPercent fill", title: "10% Off on $200", text: "10%" },
    ];

    iconsData.forEach((data) => {
      const fillIcon = document.createElement("span");
      fillIcon.className = `fillIcon ${data.className}`;
      fillIcon.dataset.bsToggle = "tooltip";
      fillIcon.title = data.title;
      fillIcon.textContent = data.text;
      cartProgressBar.appendChild(fillIcon);
    });

    list.appendChild(cartProgressBar);
  });
}
